import { AnyAction, createAsyncThunk, ThunkDispatch } from "@reduxjs/toolkit"
import {
    saveUpdateDashboardWidgets,
} from "../../graphql/mutations";
import {
    getDailyChartAlertQuery,
    getDashboardOrderData,
    getEnvironmentRiskScore,
    getRecentNotifications,
    getStackRankingData,
    getSubstanceFrequencyData
} from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import { setLoader } from "../slices/authSlice";
import { notificationFail, notificationSuccess } from "../slices/notificationSlice";
import { DailyAlertDataType, EnvironmentRiskScoreChartDataType, NotificationDataType, StackRankingDataType, substanceFrequencyDataType } from "../../components/dashboard/types";
import { setEnvironmentRiskScoreChartData } from "../slices/mainDashboardSlice";
import { ChangeServiceRequest } from "./commonThunk";
import { devApi, prodApi, qaApi } from "../../aws-export";
import DashboardDummyData from './dashboard_dummydata.json'

const loginwithtype = process.env.REACT_APP_ENVIRONMENT;
export const saveDashboardWidgetsSorting = createAsyncThunk("saveUpdateDashboardWidgets", async (req: { username: string, dashboard_order: string }, { dispatch }) => {
    dispatch(setLoader(true));
    try {
        const response = (await API.graphql({
            ...graphqlOperation(saveUpdateDashboardWidgets, { saveRequestDashboardWidgets: req }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        })) as { data: { saveUpdateDashboardWidgets: { success: string } } };
        dispatch(setLoader(false));
        if (response?.data?.saveUpdateDashboardWidgets?.success === "true") {
            dispatch(notificationSuccess("Widgets order updated successfully."));
        } else {
            dispatch(notificationFail("failed to update widgets order."));
        }
        dispatch(getDashboardWidgetsSorting({ username: req?.username }));
    } catch (err) {
        dispatch(setLoader(false));
        dispatch(notificationFail("failed to update widgets order."));
        console.log(err)
    }
});

export const getDashboardWidgetsSorting = createAsyncThunk("getDashboardWidgetsSorting", async (req: { username: string }, { dispatch }) => {
    try {
        await changeServiceHandler(dispatch);
        dispatch(setLoader(true));
        const response = (await API.graphql({
            ...graphqlOperation(getDashboardOrderData, { getDashboardWidgetRequest: req }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        })) as { data: { getDashboardOrderData: { result: string } }; errors: any[] };
        localStorage.setItem("dashboardWidgetOrder", response?.data?.getDashboardOrderData?.result);
        const data = JSON.parse(response?.data?.getDashboardOrderData?.result || "[]");
        dispatch(setLoader(false));
        return data;
    } catch (err) {
        dispatch(setLoader(false));
        console.log(err)
        return [];
    }
});

export const getRecentNotificationData = createAsyncThunk("getRecentNotifications", async (req: { tenantId: string, facilityKey?: string, locationId?: string }, { dispatch }) => {
    try {
        await changeServiceHandler(dispatch);
        const response = (await API.graphql({
            ...graphqlOperation(getRecentNotifications, { recentNotificationRequest: req }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        })) as {
            data: { getRecentNotificationList: NotificationDataType[] }; errors: any[]
        };
        return response?.data?.getRecentNotificationList || [];
    } catch (err) {
        console.error("err ", err);
        dispatch(notificationFail("failed to fetch recent notification data."));
        return []
    }
});

export const getDailyAlertData = createAsyncThunk("getDailyAlerts", async (req: { tenantCode: string, facilityKey?: string, startDate: number, endDate: number }, { dispatch }) => {
    try {
        await changeServiceHandler(dispatch);
        const response = (await API.graphql({
            ...graphqlOperation(getDailyChartAlertQuery, { dailyAlertRequest: req }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        })) as { data: { getDailyChartAlertData: DailyAlertDataType[] } };
        return response?.data?.getDailyChartAlertData || [];
    } catch (err) {
        dispatch(notificationFail("failed to fetch daily alerts data"));
        console.error("err", err);
        return []
    }
});


export const getEnvironmentRiskScoreData = createAsyncThunk("getEnvironmentRiskScoreData", async (req: { tenantCode: string, facilityKey?: string, locationId?: string; startDate: number, endDate: number, prevStartDate: number, prevEndDate: number, riskStartDate: number, riskEndDate: number }, { dispatch }) => {
    type responseType = { data: { getRiskScoreData: { riskScore: number, entryScores: EnvironmentRiskScoreChartDataType[] } } }
    try {   
            if(req.tenantCode !== process.env.REACT_APP_TENANT_CODE){
                await changeServiceHandler(dispatch);
                const currentRisk = (API.graphql({
                    ...graphqlOperation(getEnvironmentRiskScore, {
                        riskScoreRequest: {
                            tenantCode: req.tenantCode,
                            facilityKey: req?.facilityKey,
                            locationId: req?.locationId,
                            startDate: req.startDate,
                            endDate: req.endDate,
                            riskStartDate: req.riskStartDate,
                            riskEndDate: req.riskEndDate
                        }
                    }),
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })) as Promise<responseType>;
                const prevRisk = API.graphql({
                    ...graphqlOperation(getEnvironmentRiskScore, {
                        riskScoreRequest: {
                            tenantCode: req.tenantCode,
                            facilityKey: req.facilityKey,
                            locationId: req?.locationId,
                            startDate: req.prevStartDate,
                            endDate: req.prevEndDate,
                        }
                    }),
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                }) as Promise<responseType>;        
                    const [currentScore, prevScore] = await Promise.all([currentRisk, prevRisk]).then((response) => {
                    return [
                        (response?.[0]?.data?.getRiskScoreData || 0),
                        (response?.[1]?.data?.getRiskScoreData || 0)
                    ]
                });
                dispatch(setEnvironmentRiskScoreChartData(currentScore?.entryScores))
                return { currentScore: currentScore?.riskScore, prevScore: prevScore?.riskScore - currentScore?.riskScore, }
        }else{
             await changeServiceHandler(dispatch);        
            const  differenceInDays = getDayDifferent(req.startDate, req.endDate)           
            console.log('differenceInDays',differenceInDays);                                
            const dummyData = DashboardDummyData.data.getRiskScoreData; 
            if(differenceInDays == 30){
                 dispatch(setEnvironmentRiskScoreChartData(DashboardDummyData.data.getRiskScoreData.last30Days.entryScores))
                return { 
                    currentScore: Number(dummyData.last30Days.riskScore), 
                    prevScore: Number(dummyData.last30Days.riskScore),
                }
            }else if(differenceInDays == 60){
                dispatch(setEnvironmentRiskScoreChartData(DashboardDummyData.data.getRiskScoreData.last60Days.entryScores))
                return { 
                    currentScore: Number(dummyData.last60Days.riskScore), 
                    prevScore: Number(dummyData.last60Days.riskScore),
                }
            }else{
                 dispatch(setEnvironmentRiskScoreChartData(DashboardDummyData.data.getRiskScoreData.last90Days.entryScores))
                return { 
                    currentScore: Number(dummyData.last90Days.riskScore), 
                    prevScore: Number(dummyData.last90Days.riskScore),
                }
            }
           
        }
        
    } catch (err) {
        console.log("err ", err);
        dispatch(notificationFail("failed to fetch environment threshold score."));
        return { currentScore: 0, prevScore: 0, environmentRiskScoreChartDataType: [] }
    }
});

export const getStackRankingDataThunk = createAsyncThunk("getStackRankingData", async (req: { tenantCode: string; facilityKey?: string; locationId?: string; location?: string; startDate: number; endDate: number }, { dispatch }) => {
    try {
        if(req.tenantCode !== process.env.REACT_APP_TENANT_CODE){
            await changeServiceHandler(dispatch);
            const response = await API.graphql({
                ...graphqlOperation(getStackRankingData, { stackRankingRequest: req })
            }) as { data: { getStackRanking: StackRankingDataType[] } };
            return response?.data?.getStackRanking || []
        }else{
            const  differenceInDays = getDayDifferent(req.startDate, req.endDate)  
            console.log("getStackRankingDataThunk",{differenceInDays, req});
            if(differenceInDays == 1){
                const getStackRanking:StackRankingDataType[] = DashboardDummyData.getStackRanking.data.oneDay || []
                return getStackRanking 
            }else if(differenceInDays > 1){
                const getStackRanking:StackRankingDataType[] = DashboardDummyData.getStackRanking.data.week || []
                return getStackRanking 
            }else{
                const getStackRanking:StackRankingDataType[] = DashboardDummyData.getStackRanking.data.month || []
                return getStackRanking 
            }
            
        }
    } catch (err) {
        dispatch(notificationFail("failed to fetch stack ranking data."));
        console.log("err ", err);
        return []
    }
});

export const getSubstanceFrequencyDataThunk = createAsyncThunk("getSubstanceFrequencyData", async (req: { tenantCode: string; facilityKey?: string; locationId?: string; startDate: number; endDate: number }, { dispatch }) => {
    try {
        if(req.tenantCode !== process.env.REACT_APP_TENANT_CODE){
            await changeServiceHandler(dispatch);
            const response = await API.graphql({
                ...graphqlOperation(getSubstanceFrequencyData, { substanceFrequencyRequest: req })
            }) as { data: { getSubstanceFrequency: substanceFrequencyDataType[] } };
            return response?.data?.getSubstanceFrequency || [];
        }else{
           const  differenceInDays = getDayDifferent(req.startDate, req.endDate)  
            console.log("getStackRankingDataThunk",differenceInDays);
            if(differenceInDays == 1){
                const DashboardSubstansedata:substanceFrequencyDataType[] = DashboardDummyData.getSubstanceFrequency.data.oneDay || []
                return DashboardSubstansedata
            }else if(differenceInDays > 1){
                const DashboardSubstansedata:substanceFrequencyDataType[] = DashboardDummyData.getSubstanceFrequency.data.week || []
                return DashboardSubstansedata
            }else{
                const DashboardSubstansedata:substanceFrequencyDataType[] = DashboardDummyData.getSubstanceFrequency.data.month || []
                return DashboardSubstansedata
            }            
        }
    } catch (err) {
        console.log("err ", err);
        dispatch(notificationFail("failed to fetch characteristic frequency data."));
        return [];
    }
});

const changeServiceHandler = async (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
    await dispatch(
        ChangeServiceRequest({
            request: loginwithtype === "qa" ? qaApi :
                loginwithtype === "prod" ? prodApi
                    : devApi,
        })
    );
}

const getDayDifferent = (startDate:number,endDate:number) => {

    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const differenceInMs = endDate - startDate;
    const differenceInDays = Math.ceil(differenceInMs / millisecondsPerDay);
    console.log('differenceInDays',differenceInDays);
    return differenceInDays
}
